import PropTypes from 'prop-types';
import React from 'react';
import DesignAction from './connected/design-action';
import constants from 'contest/data/constants';
import { FormattedMessage } from 'react-intl';

const VISIBLE_DESIGN_STATUSES = [
    constants.DESIGN_STATUS_TYPES_ELIMINATED,
    constants.DESIGN_STATUS_TYPES_WITHDRAWN,
    constants.DESIGN_STATUS_TYPES_DELETED,
    constants.DESIGN_STATUS_TYPES_WINNER,
];

export class StatusDesignAction extends React.Component {
    undoActionButton(hasPermission = false, action) {
        if (!hasPermission || !this.props.activeUser) {
            return null;
        }

        return (
            <span>
                &nbsp;
                <button className="button button--link" onClick={action}>
                    <FormattedMessage id="undo" />
                </button>
            </span>
        );
    }

    render() {
        if (VISIBLE_DESIGN_STATUSES.indexOf(this.props.design.status) < 0) {
            return null;
        }

        const permission = this.props.design.permission;
        let undoButton = null;
        let statusMessage;

        switch (this.props.design.status) {
            case constants.DESIGN_STATUS_TYPES_ELIMINATED:
                statusMessage = <FormattedMessage id="eliminated_status_long" />;
                undoButton = this.undoActionButton(
                    permission.canUneliminate,
                    this.props.onUndoEliminate
                );
                break;
            case constants.DESIGN_STATUS_TYPES_WITHDRAWN:
                statusMessage = <FormattedMessage id="withdrawn_status_long" />;
                undoButton = this.undoActionButton(
                    permission.canUnwithdraw,
                    this.props.onUndoWithdraw
                );
                break;
            case constants.DESIGN_STATUS_TYPES_DELETED:
                statusMessage = <FormattedMessage id="deleted_status_long" />;
                undoButton = this.undoActionButton(permission.canRestore, this.props.onUndoDelete);
                break;
            case constants.DESIGN_STATUS_TYPES_WINNER:
                if (this.props.design.permission.canAward) {
                    statusMessage = <FormattedMessage id="winner_status_ch_long" />;
                } else {
                    statusMessage = <FormattedMessage id="winner_status_non_ch_long" />;
                }
                break;
        }

        return (
            <div className="design-actions-panel__action">
                <div className="design-actions-panel__action__status">
                    {statusMessage}
                    {undoButton}
                </div>
            </div>
        );
    }
}

StatusDesignAction.propTypes = {
    design: PropTypes.shape({
        status: PropTypes.string.isRequired,
        permission: PropTypes.shape({
            canUneliminate: PropTypes.bool,
            canUnwithdraw: PropTypes.bool,
            canRestore: PropTypes.bool,
            canAward: PropTypes.bool,
        }).isRequired,
    }).isRequired,
    onUndoEliminate: PropTypes.func.isRequired,
    onUndoWithdraw: PropTypes.func.isRequired,
    onUndoDelete: PropTypes.func.isRequired,
    activeUser: PropTypes.object,
};

export default DesignAction(StatusDesignAction);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/status-design-action.jsx